//
import Model from '@/models/Model'

/**
 *
 */
export default class PchTaxDocument extends Model {
    //
    static includes = ['pch_provider', 'pch_provider_branch_offices']

    /**
     *
     */
    get is_credit() {
        return this.document_type_number === 61
    }

    /**
     *
     */
    get is_debit() {
        return this.document_type_number === 56
    }

    /**
     *
     */
    get is_invoice() {
        return this.document_type_number === 33 || this.document_type_number === 34
    }

    /**
     *
     */
    get pch_provider_branch_offices_address() {
        return this.pch_provider_branch_offices
            ? this.pch_provider_branch_offices.address
            : '-'
    }

    /**
     *
     */
    get pch_provider_business_name() {
        return this.pch_provider ? this.pch_provider.business_name : '-'
    }

    /**
     *
     */
    resource() {
        return 'pch_tax_document'
    }
}
